import { faInfoCircle, faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import { Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import { useDispatch } from "react-redux";

const ReprescribeInfoPopup = ({ closePopup, days }) => {
  const dispatch = useDispatch();

  return (
    <Modal show={true} id="prescription-popup" size="lg">
      <Modal.Body>
        <>
          <div className="prescription-detail">
            <div className="close-btn">
              <FontAwesomeIcon icon={faTimesCircle} onClick={closePopup} />
            </div>
            <div className="inner-section">
              <div className="row">
                <div className="col-md-12" style={{ color: "white" }}>
                  <p>
                    Due to recent changes in herb concentration standards (for
                    example some herbs might be concentrated at 5:1 and others
                    at 20:1), we’re upgrading how Represcriptions are handled to
                    ensure the accuracy of your formulas.
                  </p>
                  <p>
                    <strong>Here’s how it works:</strong>
                    <br></br>
                    Your prescription will first be converted to{" "}
                    <strong>RAW format.</strong> From there:
                  </p>

                  <ul style={{ marginLeft: "40px" }}>
                    <li>
                      If you need to make any adjustments, simply modify the
                      prescription in RAW format.
                    </li>
                    <li>
                      Once you’re finished, click{" "}
                      <strong>‘Convert to Granular’</strong> — our upgraded
                      system will automatically handle all the precise dosage
                      calculations for you.
                    </li>
                  </ul>

                  <p>
                    If no changes are needed, just click{" "}
                    <strong>‘Convert’</strong>, enter your instructions, and
                    you’re all set! Our software will take care of the rest,
                    ensuring every formula is accurate and consistent.
                  </p>
                  <p>
                    This is part of our ongoing commitment to providing you and
                    your patients with the{" "}
                    <strong>
                      highest quality care and precision in herbal prescribing.
                    </strong>{" "}
                    Thank you for growing with us!
                  </p>
                  {!days && (
                    <p className="info-imp">
                      Note: Serving instructions were not entered when this
                      formula was created, therefore dosages can not be
                      converted to accommodate for concentration changes. We
                      will copy your formula herbs, please enter your dosages in
                      RAW, then click Convert to Granular for accurate
                      calculations.
                    </p>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="submit-section d-flex justify-content-end">
            <button className="btn-orange" onClick={closePopup}>
              Ok
            </button>
          </div>
        </>
      </Modal.Body>
    </Modal>
  );
};
export default ReprescribeInfoPopup;
